import React from "react";
import { Helmet } from "react-helmet";

/**
 * 🔹 COMPONENTE SEO DINAMICO
 * Questo componente imposta tutti i meta tag dinamici per ogni pagina:
 * - Titolo
 * - Descrizione
 * - Open Graph (Facebook / LinkedIn / WhatsApp)
 * - Twitter Card
 * - Canonical URL
 * - Colore brand
 * 
 * ⚙️  USO:
 * <SEO 
 *   title="Titolo specifico della pagina"
 *   description="Descrizione SEO di 150-160 caratteri"
 *   url="https://andolfatto.it/percorso"
 * />
 */

function SEO({
  title = "Andolfatto Insurance Broker | Dal 1974 proteggiamo persone, professionisti e aziende con soluzioni assicurative su misura.",
  description = "Andolfatto Insurance Broker offre consulenza assicurativa indipendente per privati, professionisti e aziende. Analizziamo i rischi, selezioniamo le migliori coperture e garantiamo assistenza continua dal 1974.",
  url = "https://andolfattobroker.it",
  image = "https://andolfatto.it/assets/images/og-default.jpg",
}) {
  return (
    <Helmet>
      {/* ✅ Titolo e meta description (usati da Google) */}
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content="assicurazioni bassano, consulenza assicurativa, assicurazioni artigiani, assicurazioni professionisti, assicurazioni privati, assicurazioni su misura" />
      <meta name="author" content="Andolfatto Insurance Broker" />

      {/* ✅ Canonical URL (evita contenuti duplicati) */}
      <link rel="canonical" href={url} />

      {/* ✅ Favicon */}
      <link rel="icon" href="/favicon3.ico" type="image/x-icon" />

      {/* ✅ Theme color per Chrome e mobile */}
      <meta name="theme-color" content="#8c2b45" />

      {/* ✅ Open Graph (Facebook, LinkedIn, WhatsApp) */}
      <meta property="og:type" content="website" />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta property="og:url" content={url} />
      <meta property="og:site_name" content="Andolfatto Insurance Broker" />

      {/* ✅ Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
    </Helmet>
  );
}

export default SEO;
